export const ROL_ADMINISTRADOR = ["ADMINISTRADOR"];
export const ROL_VENDEDOR = ["VENDEDOR"];
export const ROL_CLIENTE = ["CLIENTE"];
export const ROLES_ALL = ["ADMINISTRADOR", "VENDEDOR", "CLIENTE"];
